/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import userflow from 'userflow.js'
import { decode as decodeJwt, JwtPayload } from 'jsonwebtoken'
import { adaloBackendAxios } from 'utils/io/http/axios'

export const parseJWT = (token: string | null): JwtPayload | null => {
  if (!token) {
    return null
  }
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const tokenPayload = decodeJwt(token) as JwtPayload

    const now = Math.floor(Date.now() / 1000)
    if (!tokenPayload.exp || now < tokenPayload.exp) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return tokenPayload
    }
  } catch (err: unknown) {
    const originalErrorMessage =
      err && err instanceof Error ? err.message : 'Unknown error'

    console.warn(`Invalid auth token: ${originalErrorMessage}`)
  }

  return null
}
interface MakerTokenPayload extends JwtPayload {
  userId: number
  email: string
  admin?: boolean | undefined
  developer?: boolean | undefined
}
let inMemoryToken: string | null = null
let inMemoryAuthProvider: string | null = null

const hasLocalStorage = (): boolean => {
  try {
    return !!window.localStorage
  } catch (e) {
    return false
  }
}

export const getAuthToken = (): string | null => {
  let token: string | null
  if (hasLocalStorage()) {
    token = window.localStorage.getItem('protonSession')
  } else {
    token = inMemoryToken
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const makerToken = parseJWT(token)
  if (!makerToken) {
    return null
  }

  return token
}
export const getAuthProvider = (): string | null => {
  let authProvider: string | null
  if (hasLocalStorage()) {
    authProvider = window.localStorage.getItem('protonAuthProvider')
  } else {
    authProvider = inMemoryAuthProvider
  }

  return authProvider
}

const parseMakerToken = (): MakerTokenPayload | null => {
  const makerToken = getAuthToken()

  return parseJWT(makerToken) as MakerTokenPayload | null
}

export const getMakerUserId = (): number | null => {
  const makerToken = parseMakerToken()

  if (!makerToken) {
    return null
  }

  return makerToken.userId
}

export const isMakerDeveloper = (): boolean => {
  const makerToken = parseMakerToken()

  if (!makerToken) {
    return false
  }

  return !!makerToken.developer
}

export const storeMakerToken = (token: string): void => {
  if (hasLocalStorage()) {
    window.localStorage.setItem('protonSession', token)
  } else {
    inMemoryToken = token
  }
}

export const storeMakerAuthProvider = (authProvider: string): void => {
  if (hasLocalStorage()) {
    window.localStorage.setItem('protonAuthProvider', authProvider)
  } else {
    inMemoryAuthProvider = authProvider
  }
}

export const getRawAuthToken = (): string | null => {
  if (hasLocalStorage()) {
    return window.localStorage.getItem('protonSession')
  } else {
    return inMemoryToken
  }
}

export const logoutMaker = async (): Promise<void> => {
  try {
    await adaloBackendAxios.post('/auth/logout')
  } catch (error) {
    console.warn('Failed to call backend logout endpoint:', error)
  } finally {
    userflow.reset()
    if (hasLocalStorage()) {
      window.localStorage.removeItem('protonSession')
      window.localStorage.removeItem('protonAuthProvider')
    } else {
      inMemoryToken = null
      inMemoryAuthProvider = null
    }
  }
}
